module.exports = __webpack_public_path__ + "static/CBS.b1a25ae9.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/data/press-logos/CBS.jpeg
// module id = 1055
// module chunks = 213534597649335